//lib
import { Icon } from "@iconify/react/dist/iconify.js";

//redux
import { useSelector } from "react-redux";

//component
import Col from "../../../components/element/col";
import Row from "../../../components/element/row";
import Image from "../../../components/element/image";
import { ShopHero as ShopHero1 } from "../../../assets/images";
import Button from "../../../components/element/button";
import ArrowButton from "../../../components/common/common.arrow.button";
import Container from "../../../components/element/container";

export default function ShopHero() {
  const handleScroll = () => {
    const productList = document.getElementById("product-list");
    if (productList) {
      const offset = -150;
      const top =
        productList.getBoundingClientRect().top + window.pageYOffset + offset;

      window.scrollTo({ top: top, behavior: "smooth" });
    }
  };

  return (
    <Container className="shop-hero">
      <Col className="_col hero-col">
        <h1 className="_label hero-title">Gear Up in Style.</h1>
        <p className="_label hero-subtitle">
          Explore our full lineup of premium apparel and accessories —
          engineered for comfort, crafted with precision, and inspired by the
          adrenaline of supercar culture.
        </p>
        <ArrowButton
          className="_button arrow"
          color="transparent"
          onClick={() => handleScroll()}
        />
      </Col>
      <Image src={ShopHero1} className="_img hero" />
    </Container>
  );
}
